import { Modal, Box, Button, Container, ThemeProvider, createTheme, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import './styles.css';
const ModalComponent = (props: any) => {
    const { open, closeModal, title, backgroundcolor, children } = props;
    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            BackdropProps={{
                onClick: (event) => event.stopPropagation(),
            }}
            sx={{ overflowY: "auto", display: 'flex', justifyContent: "center", margin: "0 auto", flexDirection: "column", alignItems: "center" }}
        >
            <Box
                className={'modalBox'}
                sx={{ backgroundColor: backgroundcolor }}
            >
                <Box className={'modal-header-section'}>
                    <Typography variant="h1" className={"modal-heading"}>
                        {title}
                    </Typography>
                    <CloseIcon sx={{height: "16px", width: "16px", color:"#343434", cursor: "pointer"}} onClick={closeModal} />
                </Box>
                {children}
            </Box>
        </Modal>
    )
}

export default ModalComponent;